import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import ZapierLogo from '../logos/zapier.svg';
export const GetZapierCardTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            ZapierCardTID: {
                Card: 'zapier-card',
                Connect: 'zapier-card-connect'
            }
        }
    });
export default function ZapierCard() {
    const { t: zapierTexts } = useLocaleKeys('integrations.availableApps.zapier');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('zapier');
    const { ZapierCardTID } = useMemo(()=>GetZapierCardTID(), []);
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: ZapierCardTID.Card(),
        icon: /*#__PURE__*/ _jsx(ZapierLogo, {
            width: 40,
            height: 40
        }),
        title: zapierTexts.title(),
        subTitle: zapierTexts.subtitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_zapier'
            },
            onClick: showCopyAPIKeyModal,
            testId: ZapierCardTID.Connect(),
            children: sharedTexts.connectButton()
        })
    });
}
